import { render, staticRenderFns } from "./ExcluirProdutoSilenciado.vue?vue&type=template&id=3a745b41&scoped=true"
import script from "./ExcluirProdutoSilenciado.vue?vue&type=script&lang=js"
export * from "./ExcluirProdutoSilenciado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a745b41",
  null
  
)

export default component.exports